module.exports = __webpack_public_path__ + "img/Katarina_acc_15.9ab7d3ff.jpg";